<template>
  <div class="home">
    <el-image :src="header"></el-image>
    <div class="serach">
      <div class="title">中奖查询</div>
      <div class="input-buttom">
        <el-input :placeholder="`请输入订单编号`" size="small" @blur="winAPrizeSerach" v-model.trim="nickNameOrOrderNo" clearable class="inputWidthHeader">
          <template slot="append">
            <el-button @click="winAPrizeSerach">查询</el-button>
          </template>
        </el-input>
      </div>
      <div class="result" v-if="tableData1.length && this.winAPrizeType">
        <img src="../../assets/images/success.png" style="width: 20px;hieght:20px" class="imgMargin"/>
        <span class="orange">{{ "\xa0" }}恭喜您! {{ "\xa0" }} 中奖啦! </span> <span class="black">{{ "\xa0" }} 下面是你的中奖信息。</span>
      </div>
      <div class="result" v-else-if="!tableData1.length && this.winAPrizeType">
        <img src="../../assets/images/fail.png" style="width: 20px;hieght:20px" class="imgMargin"/>
        <span class="black">{{ "\xa0" }}不好意思, {{ "\xa0" }}没有查询到您的中奖信息!</span>
      </div>
      <div  class="tableClass" v-if="tableData1.length && this.winAPrizeType">
        <el-table :data="tableData1" border ref="myTable" :row-style="{height:'32px'}" :cell-style="{padding: '0'}">    
          <el-table-column prop="activityTitle" label="标题" align="center" min-width="80" show-overflow-tooltip></el-table-column>
          <el-table-column prop="rankingNumber" label="排名" width="80" align="center"></el-table-column>
          <!-- <el-table-column prop="customerNickName" label="买家ID" align="center" min-width="80" v-if="!storeName.includes('TM')" show-overflow-tooltip></el-table-column> -->
          <el-table-column prop="orderNo" label="订单编号" align="center" min-width="80" show-overflow-tooltip></el-table-column>
          <el-table-column prop="payTime" label="支付时间" align="center" min-width="80" show-overflow-tooltip></el-table-column>
          <!-- <el-table-column prop="accumulatedAmount" label="累计金额" align="center"></el-table-column> -->
          <el-table-column prop="discount" label="优惠" align="center" min-width="80" show-overflow-tooltip></el-table-column>
        </el-table>
        </div>
    </div>
    <div class="serach">
      <div class="title">活动列表</div>
      <div style="margin-top: 20px">
        <el-form
          :inline="true"
          size="small"
          :model="searchForm"
          class="search-wrapper"
          ref="ruleForm"
        >
          <el-form-item label="标题" :label-width="windowWidth < 1000 ? '36px' : '40px'">
            <el-input v-model.trim="searchForm.activityTitle" clearable class="inputWidth40"></el-input>
          </el-form-item>
          <el-form-item label="活动时间" :label-width="windowWidth < 1000 ? '65px' : '70px'">
            <!-- <el-input v-model.trim="searchForm.activityDate" > -->
              <el-date-picker
                class="dateWidth"
                :editable="false"
                v-model="searchForm.activityDate"
                type="date"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            <!-- </el-input> -->
          </el-form-item>
          <el-form-item>
            <el-button class="buttomColor" size="small" @click="activitysSerach">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="tableClass2">
        <el-table :data="tableData.records" border ref="myTable2" :row-style="{height:'32px'}" :cell-style="{padding: '0'}" max-height="300" @row-click="tableClick">    
          <el-table-column prop="activityTitle" label="标题" align="center" min-width="80" show-overflow-tooltip></el-table-column>
          <el-table-column prop="address" label="活动时间" align="center" min-width="80" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.startDate + '~' + scope.row.endDate}}</template>
          </el-table-column>
        </el-table>
        <div class="paging">
          <el-pagination
            :small="windowWidth < 1000"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-size="tableData.pageSize"
            layout=" prev, pager, next, jumper"
            background
            :total="tableData.total"
          ></el-pagination>
        </div>
      </div>
      <div class="grey" v-if="storeName.includes('TM')">
        <p>优惠细则</p>
        <p>▶为保障活动公平公正，本店所有免单、半价、返现、单品红包等营销活动中，出现0秒下单且0秒付款的订单均判定为使用作弊软件操作，直接取消其中奖/参与资格；</p>
        <p>▶店铺免单、返现等优惠活动，均为确认收货后联系客服领取；</p>
        <p>▶需在指定时间段内提交订单并付款，活动时间开始前提交订单不参与排名；加购付款后系统会自动拆分订单，按最终拆单后的订单号核算订单笔数；优惠资格按订单付款时间为准，付款时间相同按订单编号小的优先，限活动时间开始后提交订单并付款（非预售活动商品在活动开始后提交订单并付款方可计算排名，预售活动商品按照订单付尾款时间排名）；</p>
        <p>▶页面标注的到手价，是针对单个商品单个订单且领取足够满减券情况下计算所得，多个订单或者多个商品在一个订单，实际到手价会有差异，下单时请注意，具体价格请咨询客服；</p>
        <p>▶每个买家ID仅享受1次优惠，同一收货人或手机号码或收货地址将视为同一买家ID处理，如订单不满足活动要求，则优惠不计且名额不顺延，出现退、换货等情况则取消优惠资格；</p>
        <p>▶最终付款金额=订单支付金额-送装费-优惠退差-退款-平台补贴-政府补贴-返现，当订单金额低于红包金额时，返现以订单金额为准；</p>
        <p>▶同一买家ID，同一链接商品仅限享受1次单品红包，以较大优惠为准，预售活动特殊情形：顾客参加某商品抢付定金排名红包活动，又参加抢付尾款排名活动，仅限获取其中1次排名红包；单件商品预售价≥1500元核算为1件;</p>
        <p>▶购买餐桌或者茶几电视柜产品，仅限餐桌椅组合或者茶几电视柜组合可享受单品红包；购买床类商品，单独售卖的床头柜不享受单品红包；购买沙发类商品，单独售卖的单椅、脚凳及头枕不享受单品红包；购买柜类商品，单独售卖的顶柜不享受单品红包；</p>
        <p>▶由于部分产品参数由系统生成，与实际产品参数存在不一致，具体咨询客服或见商品详情页下方描述；</p>
        <p>▶换购产品、品牌秒杀产品，下单付款后不支持更改颜色，且不支持等通知发货；</p>
        <p>▶部分商品内部分标记换购规格产品需主订单最终付款金额≥800元或单独换购规格最终付款金额≥800元方可发货，如未满足，则无法发货；</p>
        <p>▶店铺所有涉及关于价格折扣类、半价及活动优惠类信息的描述，仅限该产品指定规格且均以该指定规格促销价（活动价）为参照价计算，并非是全部规格或者其他任何价格对应折扣、半价或活动优惠，具体指定规格详询客服；</p>
        <p>▶关于同价描述的说明，指的是商品券后价或付款价与某指定活动时段商品</p>

      </div>
      <div class="grey" v-else-if="storeName.includes('JD')">
        温馨提示：
        <p>1.活动排名规则：前xx笔，前xx名，优惠资格按订单付款时间先后排序，付款时间相同则按订单号最后6位数由小到大排序获得优惠资格，若最后6位数相同则以后7位数由小到大排序，以此类推，限活动时间开始后提交订单并付款，活动时间开始前提交订单不参与排名;</p>
        <p>2.返红包名额需联系客服查询，满足条件确认收货后需15天内联系客服返差（按订单实付与商品主图公示的到手价退差额），未使用平台优惠券及政府补贴情况商家不退差；</p>
        <p>3.官方补贴券使用规则:同款购买多件或不同款购买多件情况，平台补贴券仅限使用一次（主图上补贴到手价仅限第一件补贴后优惠)，请悉知，如想多次使用补贴请更换购物账号；</p>
        <p>4.退换货(包含换尺寸、款式和颜色等)或更改收货信息及退款等不满足活动条件视为自动放弃优惠资格，且名额不顺延</p>
        <p>5.商品返红包名额件数规则：以商品整个链接下参与返红包所有组合的销售件数相加核算，活动期间内同一买家ID在同一链接下购买多件并符合返红包条件，仅享受其中1件商品的一次返红包活动，择高返现，同一收货人或手机号码或收货地址将视为同一买家ID处理，因主图切换时间产生的争议，最终优惠信息以交易快照为准；</p>
        <p>6.保价细则：政府补贴、平台补贴券、膨胀券、惊喜券、PLUS券等各类平台优惠，限时限量等红包返现不在保价范围，订单仅可保价1次，保价时效为订单发货后30天内可联系客服核实；</p>
        <p>7.最终付款金额=订单支付金额-未使用优惠卡券退差金额-送装服务费-单品红包-政府补贴等（即使用店铺及平台所有满减、打折、优惠券、红包补贴、店铺其他补贴、政府补贴等最终到手价）；</p>
        <p>8.为保障活动公平公正，维护广大消费者合法权益，本店铺所有免单、半价、返现等营销活动，出现0秒下单且0秒付款的订单，均视为非常规操作，取消其活动参与资格/中奖资格。</p>
        <p>*更多细则进店了解或咨询客服</p>
      </div>
    </div>
    <div class="footer">
      <el-image :src="footer" class="imgSize"></el-image>
    </div>
  </div>
</template>
<script>
import header from "../../assets/images/header.png";
import footer from "../../assets/images/logo.png";
export default {
  name: "Home",
  data() {
    return {
      header: header,
      footer: footer,
      nickNameOrOrderNo: '',
      tableData1: [],
      storeName: '天猫一店',
      winAPrizeType: false,
      searchForm: {

      },
      tableData: {
        records: [],
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
    };
  },
  computed: {
    windowWidth() {
      return window.innerWidth
    }
  },
  mounted() {
    console.log(window.innerWidth);
    this.storeName = this.$route.query.s
    this.activitysSerach()
  },
  methods: {
    winAPrizeSerach() {
      if(!this.nickNameOrOrderNo) {
        this.winAPrizeType = false
        return
      }
      let data ={
        storeName: this.storeName,
        nickNameOrOrderNo: this.nickNameOrOrderNo
      }
      this.$api.lotteryQuery.awardOrders(data).then(res=> {
        this.tableData1 = res.data || []
        this.winAPrizeType = true
      })
    },
    activitysSerach() {
      let data ={
        storeName: this.storeName,
        activityDate: this.searchForm.activityDate,
        activityTitle: this.searchForm.activityTitle,
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
      }
      this.$api.lotteryQuery.activitys(data).then(res=> {
        this.tableData = res.data || []
      })
    },
    tableClick(row) {
      console.log(row)
      this.$router.push({
        path: '/details',
        query: {
          // ...row,
          startDate: row.startDate,
          endDate: row.endDate,
          activityTitle: row.activityTitle,
          storeName: this.storeName,
          fileId: row.fileId
        }
      })
    },
    handleCurrentChange(val) {
      this.tableData.pageNum = val
      this.activitysSerach()
    },
    handleSizeChange(val) {
      this.tableData.pageNum = 1
      this.tableData.pageSize = val
      this.activitysSerach()
    },
  }
};
</script>
<style lang="stylus" scoped>
.home {
  width: auto;
  height: 100%;
  overflow-y: auto
  background: #fff;

  .serach {
    width: 70%
    margin:  0 auto
    padding-top: 55px;
    text-align: center;

    .title {
      text-align: center;
      font-size: 36px;
      font-weight: 600;
      color: #2B2B2B;
    }
  }
  .footer {
    width: 70%
    margin: 0 auto
    text-align: center;
    padding: 142px 0  50px 0
  }
}

.inputWidthHeader {
  width: 424px
}

.result {
  display: flex
  align-items: center
  justify-content: center
  font-size: 14px
}


.orange {
  color: #F41715
}

.black {
  color: #2B2B2B
}

.grey {
  color: #9B9B9B;
  text-align: left
  margin-top: 42px
}

.input-buttom {
  margin-top: 26px;
  margin-bottom: 65px
}

.tableClass {
  padding-top: 46px;
  width:100%; 
  margin: 0 auto
  overflow: hidden
}

.tableClass2 {
  padding-top: 26px;
  width:100%; 
  margin: 0 auto
  overflow: hidden
}

.paging {
  float:right;
  margin-top:34px
}

.input-buttom >>> .el-input__inner {
  border: 1px solid #F72F1D
}

>>> .el-input__inner:focus{
  border-color:#F05239;
}

>>> .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #F05239
}

>>> .el-input-group__append, .el-input-group__prepend {
  background: linear-gradient(185deg, #EF3231, #FF6B31);
  color: #FFFFFF;
  border: 1px solid #f72f1d;
}

.buttomColor {
  background: linear-gradient(185deg, #EF3231, #FF6B31);
  color: #FFFFFF;
  border: 1px solid #f72f1d;
  height: 30px
}

>>> .el-table{
    border-radius: 4px;
    border-top:1px solid #D7D7D7;
    border-left:1px solid #D7D7D7;
    border-right:1px solid #D7D7D7;
    border-bottom:1px solid #D7D7D7;
}

>>> .el-table .el-table__header th {
  background: #f05239 !important
  height: 2.5rem
  color: #FFFFFF
}

.dateWidth {
  width: 200px
}

.inputWidth40{
    position: relative !important;
}

.inputWidth40 .el-date-editor {
    position: absolute ;//绝对定位
    top: 0 ;
    left: 0 ;
    opacity: 0;//设置完全透明
}


</style>
<style scoped>
  @media screen and (max-width: 1000px) {
   * {
     font-size: 12px;
   }
   .home  .serach {
    width: 100%;
    margin:  0 auto;
    padding-top: 15px;
    text-align: center;
  }
  .home .serach .title {
      text-align: center;
      font-size: 22px;
      font-weight: 600;
      color: #2B2B2B;
    }
  .input-buttom {
    margin-top: 15px;
    margin-bottom: 25px;
  }
  .inputWidthHeader {
    width: 80%
  }
  .tableClass {
    padding-top: 20px
  }
  .grey {
    padding: 0 5px;
    font-size: 12px;
  }
  .inputWidth40 {
    width: 100px
  }
  .buttomColor {
    padding: 5px 8px
  }
  .tableClass2 {
    padding: 0;
  }
  .home .footer {
    margin: 0 auto;
    text-align: center;
    padding: 50px 0 30px 0;
  }
  .imgSize {
    width: 200px;
    height: 50px;
  }
  ::v-deep .el-form--inline .el-form-item__label {
    font-size: 12px;
  }
  .paging {
    margin-top: 15px;
  }
  .imgMargin {
    margin-top: -2px;
  }
  .dateWidth {
    width: 100px
  }
  ::v-deep .el-input--prefix .el-input__inner {
    padding-left: 10px;
  }
  ::v-deep .el-input--suffix .el-input__inner {
    padding-right: 20px;
  }
  ::v-deep .el-icon-date:before {
    display: none;
  }
}
@media screen and (max-width: 360px) {
  .inputWidth40 {
    width: 90px
  }
  .dateWidth {
    width: 90px
  }
   ::v-deep .el-input--suffix .el-input__inner {
    padding-right: 0px;
  }
  ::v-deep .el-icon-circle-close {
    margin-right: -8px;
  }
}
</style>
